import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

const PARAMS_KEY = "commute_params";
const STOP_PARAM_KEYS = ["homeBus", "homeMetro", "homeCabi", "workBus", "workMetro", "workCabi"];

// iOS strips query params when launching a PWA from the home screen.
// Save full stop params when present; restore via replaceState before rendering.
// Only save when stop params are present — don't overwrite a good set with a partial URL.
const hasStopParams = STOP_PARAM_KEYS.some(
  (k) => new URLSearchParams(window.location.search).has(k)
);

if (hasStopParams) {
  localStorage.setItem(PARAMS_KEY, window.location.search);
} else {
  // No stop params present — URL is either empty or only has ?n=xxx.
  // Restore the full saved params so the app can load without re-setup.
  const saved = localStorage.getItem(PARAMS_KEY);
  if (saved) {
    history.replaceState(null, "", saved);
  }
}


class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: Error | null }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: "2rem", fontFamily: "monospace", color: "#c00" }}>
          <strong>App failed to load</strong>
          <pre style={{ marginTop: "1rem", whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: "0.85em" }}>
            {this.state.error.message}
            {"\n"}
            {this.state.error.stack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
}
